'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.snapshotItemClassName = snapshotItemClassName;
exports.actionTitle = actionTitle;
exports.snapshotItemTitle = snapshotItemTitle;
function snapshotItemClassName(snapshotItem) {
  switch (snapshotItem.type) {
    case 'Effect':
      return 'is-warning';
    case 'Commit':
      return 'is-danger';
    case 'GetState':
      return 'is-success';
    default:
      return '';
  }
}


function taggedUnionTitle(taggedUnion) {
  if ((typeof taggedUnion === 'undefined' ? 'undefined' : _typeof(taggedUnion)) === 'object' && taggedUnion !== null && typeof taggedUnion.type == 'string') {
    var type = taggedUnion.type;

    var subTitle = Object.keys(taggedUnion).sort().reduce(function (accumulator, key) {
      return !accumulator && (typeof taggedUnion === 'undefined' ? 'undefined' : _typeof(taggedUnion)) === 'object' && taggedUnion !== null ? taggedUnionTitle(taggedUnion[key]) : accumulator;
    }, null);
    return subTitle ? type + '/' + subTitle : type;
  }
  return null;
}

function taggedUnionTitleOrDefault(taggedUnion) {
  return taggedUnionTitle(taggedUnion) || 'unknown';
}

function actionTitle(action) {
  return taggedUnionTitleOrDefault(action);
}

function snapshotItemTitle(snapshotItem) {
  switch (snapshotItem.type) {
    case 'Commit':
      return taggedUnionTitleOrDefault(snapshotItem.commit);
    case 'Effect':
      return taggedUnionTitleOrDefault(snapshotItem.effect);
    default:
      return snapshotItem.type;
  }
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/devtools/dist/main/util.js
 ** module id = 119
 ** module chunks = 0
 **/